<template>
	<div id="home" :style="'height:' + height + 'px;'">
		<el-carousel :height="height + 'px'" direction="horizontal" :autoplay="true" @change="change">
			<el-carousel-item v-for="item in 3" :key="item" class="banner" :id="'banner-' + item"></el-carousel-item>
		</el-carousel>
		<div title>
			<div class="container">
				<div v-if="page == 1" page="1">
					<h1>大中华区较专业的投资银行机构</h1>
					<p>Most Professional Investment Bank Agency in China</p>
				</div>
				<div v-if="page == 2" page="2">
					<h1>
						美信拥有丰富的
						<span>IPO</span>咨询服务经验
					</h1>
					<p>自2009年以来，美信咨询已经为300多家企业提供了IPO咨询服务，合计融资金额超过100亿人民币。</p>
				</div>
				<div v-if="page == 3" page="3">
					<h1>专业的顾问服务团队</h1>
					<p>美信拥有几十名专业的投资银行顾问，具有注册会计师、律师资格证的专业资质，大都拥有知名券商、会计师事务所、律师事务所从业经验。</p>
				</div>
			</div>
		</div>
		<div info>
			<div class="container">
				<div>
					<div>
						<h5>项目交易</h5>
						<ul>
							<li>
								<a>美信咨询助力中国国检投资、中银金融投资完成对...</a>
							</li>
							<li>
								<a>美信咨询助力中国国检资产投资有限公司完成福建...</a>
							</li>
							<li>
								<a>美信咨询助力京东物流收购上市公司清新环境控制...</a>
							</li>
						</ul>
						<a href more>更多</a>
					</div>
					<div>
						<div>
							<router-link :to="{name:'advantage'}">
								<h5>
									<span>专业人员</span>
									<span>Professionals</span>
								</h5>
							</router-link>
						</div>
						<div>
							<router-link :to="{name:'special'}">
								<h5>
									<span>专业领域</span>
									<span>Practice Areas</span>
								</h5>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import { Carousel, CarouselItem } from 'element-ui';
	Vue.use(Carousel);
	Vue.use(CarouselItem);
	export default {
		beforeRouteEnter(to, from, next) {
			next();
		},
		data() {
			return {
				page: 0,
			};
		},
		computed: {
			height() {
				return window.innerHeight;
			}
		},
		methods: {
			change(index) {
				this.page = index + 1;
			}
		}
	}
</script>
